import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class OnboardingScreen implements AnalyticsObject {
  name: string
  properties: OnboardingProperties
  constructor(properties: OnboardingProperties) {
    this.name = `Onboarding Screen`
    this.properties = properties
  }
}
export interface OnboardingProperties extends AnalyticsProperties {
  screen?: string
}
